import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const SimmonsBlogs = ({ blogs }) => {
  if (blogs.length > 0) {
    const topBlogs = _.filter(blogs, (item, i) => i < 9);
    const renderBlogs = _.map(topBlogs, blog => {
      const title = blog.title.rendered;
      const link = blog.link;
      const image = blog._embedded['wp:featuredmedia'][0].source_url;
      return (
        <div key={blog.id} className="blog" style={{ backgroundImage: `url(${image})` }}>
          <img src={image} alt={title} />
          <a href={link} rel="noopener noreferrer" target="_blank" className="blog-button">
            <span dangerouslySetInnerHTML={{ __html: title }} />
          </a>
        </div>
      );
    });
    return (
      <div className="blog-container"> {renderBlogs} </div>
    );
  }
  return (
    <div className="blog-container">
      <div className="lds-ripple">
        <span />
        <span />
      </div>
    </div>
  );
};
const blogArray = PropTypes.shape({});
SimmonsBlogs.propTypes = {
  blogs: PropTypes.arrayOf(blogArray),
};

export default SimmonsBlogs;
